import { BreathingButton } from "../enum/breathing-button";

export const BREATHING_BUTTON_LABELS = {
  [BreathingButton.begin]: "Begin",
  [BreathingButton.anotherExercise]: "Try another breath exercise",
  [BreathingButton.bellyBreathing]: "Belly Breathing",
  [BreathingButton.fourSevenEightBreathing]: "4-7-8 Breathing",
  [BreathingButton.rollBreathing]: "Roll Breathing",
};
